var map = {
	"./amaranth.png": 2430,
	"./ancientfruit.png": 7334,
	"./artichoke.png": 3695,
	"./beet.png": 5361,
	"./bg.jpg": 377,
	"./blueberry.png": 7344,
	"./bluejazz.png": 6036,
	"./bokchoy.png": 8022,
	"./cactusfruit.png": 8682,
	"./cauliflower.png": 7855,
	"./coffeebean.png": 6489,
	"./corn.png": 7037,
	"./cranberry.png": 2843,
	"./eggplant.png": 8291,
	"./fairyrose.png": 9833,
	"./garlic.png": 4958,
	"./gold.png": 5145,
	"./grape.png": 423,
	"./greenbean.png": 4723,
	"./hops.png": 1903,
	"./hotpepper.png": 1079,
	"./kale.png": 2135,
	"./melon.png": 2009,
	"./parsnip.png": 9488,
	"./pineapple.png": 8866,
	"./poppy.png": 8482,
	"./potato.png": 1489,
	"./pumpkin.png": 7282,
	"./radish.png": 6564,
	"./redcabbage.png": 5245,
	"./rhubarb.png": 7318,
	"./starfruit.png": 7385,
	"./strawberry.png": 6594,
	"./summerspangle.png": 8573,
	"./sunflower.png": 8130,
	"./sweetgemberry.png": 1124,
	"./taroroot.png": 2263,
	"./tealeaves.png": 3212,
	"./tomato.png": 7424,
	"./tulip.png": 9659,
	"./unmilledrice.png": 1332,
	"./wheat.png": 2961,
	"./yam.png": 8281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;